import { useMemo } from 'react';
import { getBalanceMultiplier, getVipLevel } from '../config/gameConfig';
import { useLilapeBalance } from './useLilapeBalance';
import { useTon } from '../TelegramTonProvider';

const STORAGE_VIP_SPENT = 'lilape_vip_total_spent';

// Get total TON spent from localStorage
const getTotalSpent = () => {
  try {
    return parseFloat(localStorage.getItem(STORAGE_VIP_SPENT) || '0');
  } catch {
    return 0;
  }
};

// Record a TON purchase
export const recordTonSpent = (amount) => {
  try {
    const current = getTotalSpent();
    localStorage.setItem(STORAGE_VIP_SPENT, String(current + amount));
  } catch {}
};

// Hook to get current multiplier info
export const useMultiplier = () => {
  const { connected, address } = useTon();
  const { balance } = useLilapeBalance(connected ? address : null);

  const balanceTier = useMemo(() => {
    return getBalanceMultiplier(balance || 0);
  }, [balance]);

  const vipLevel = useMemo(() => {
    return getVipLevel(getTotalSpent());
  }, []);

  // Combined multiplier = balance tier * VIP bonus
  const totalMultiplier = useMemo(() => {
    return balanceTier.multiplier * vipLevel.multiplier;
  }, [balanceTier.multiplier, vipLevel.multiplier]);

  // Apply multiplier to a win amount
  const applyMultiplier = (amount) => {
    return Math.floor(amount * totalMultiplier);
  };

  // Get next tier info for upgrade prompt
  const nextBalanceTier = useMemo(() => {
    const tiers = [
      { min: 25_000_000_000, name: 'Bronze', mult: 1.5 },
      { min: 50_000_000_000, name: 'Silver', mult: 2.0 },
      { min: 100_000_000_000, name: 'Gold', mult: 3.0 },
    ];
    const currentBalance = balance || 0;
    return tiers.find(t => t.min > currentBalance);
  }, [balance]);

  return {
    balance,
    balanceTier,
    vipLevel,
    totalMultiplier,
    applyMultiplier,
    nextBalanceTier,
    totalTonSpent: getTotalSpent(),
  };
};

export default useMultiplier;
